<table>
  <colgroup>
    <col width="30%">
    <col width="70%">
  </colgroup>
  <tbody>
    <tr>
      <td colspan=2>
        <i class="fa fa-2x" [ngClass]="statusInfo.cssClass" aria-hidden="true"></i>
      </td>
    </tr>
    <tr>
      <td>Status</td>
      <td>{{ statusInfo.text | translate }}</td>
    </tr>
    <tr *ngIf="!ticket.isUnknown && !isStaff">
      <td>{{ 'Product' | translate }}</td>
      <td>{{ productName }}</td>
    </tr>
    <tr *ngIf="!ticket.isUnknown && !isStaff  && ticket.isAdditionalTicket">
      <td>{{ 'Ticket type' | translate }}</td>
      <td>{{ 'Additional ticket' | translate }}</td>
    </tr>
    <tr>
      <td>Ticket</td>
      <td>{{ ticket.code }}</td>
    </tr>
    <tr *ngIf="viewQuantityInfo">
      <td>{{ 'Quantity' | translate }}</td>
      <td>{{ ticket.quantity }}</td>
    </tr>
    <tr *ngIf="viewQuantityInfo">
      <td>{{ 'Remaining quantity' | translate }}</td>
      <td>{{ ticket.quantityRemaining }}</td>
    </tr>
    <tr *ngIf="!ticket.isUnknown && isRoleExit && ticket.totalOvertime > 0 && !ticket.validUntil">
      <td>{{ 'Total overtime' | translate }}</td>
      <td>{{ ticket.totalOvertime }} {{ 'minutes' | translate }}</td>
    </tr>
    <tr *ngIf="!ticket.isUnknown  && isRoleExit && ticket.outstandingOvertime > 0 && !ticket.validUntil">
      <td>{{ 'Oustanding overtime' | translate }}</td>
      <td>{{ ticket.outstandingOvertime }} {{ 'minutes' | translate }}</td>
    </tr>
    <tr *ngIf="ticket.validUntil && isTicketValid && !ticket.isAdditionalTicket">
      <td>{{ 'Valid Until' | translate }}</td>
      <td>{{ ticket.ValidUntilString }}</td>
    </tr>
  </tbody>
</table>
